import React from "react";

const Ellipse = ({...r}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 6" {...r}>
      <circle cx="3" cy="3" r="2.5" stroke="#E4E4E4"></circle>
    </svg>
  );
}

export default Ellipse;